import React from "react";
import { Route, Redirect } from "react-router-dom";
import useAdmin from "@/src/hooks/useAdmin";
import { useAuth } from "@/src/hooks/useAuth";

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  path: string;
  // Implemented below but never passed by any caller, which is why
  // /account-managers has no client-side admin gate. Kept so the fix has
  // somewhere to land — see src/hooks/AGENTS.md.
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  requireAdmin = false,
  ...rest
}) => {
  const isAdmin = useAdmin();
  const { isAuthenticated } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return <Redirect to="/auth/login" />;
        }

        if (requireAdmin && !isAdmin) {
          return <Redirect to="/users" />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
